import { Link } from 'react-router-dom';

const CTA_IMAGE =
  'https://readdy.ai/api/search-image?query=wide%20banner%20illustration%20of%20steaming%20caramel%20pudding%20desserts%20and%20hot%20cocoa%20cups%20on%20warm%20cozy%20gradient%20background%2C%20cream%20orange%20tones%2C%20clean%20flat%20modern%20vector%20style%2C%20appetizing%20cozy%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=500&seq=cta-banner-2026&orientation=landscape';

export default function CtaBanner() {
  return (
    <section className="mx-auto max-w-7xl px-4 pb-12 md:px-6 md:pb-16">
      <div className="relative overflow-hidden rounded-3xl">
        <div className="relative h-[300px] w-full md:h-[340px]">
          <img
            src={CTA_IMAGE}
            alt="布丁漫画网追更提醒"
            title="布丁漫画网新章节第一时间更新"
            className="absolute inset-0 h-full w-full object-cover object-center"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/75 via-foreground-950/50 to-foreground-950/25"></div>
        <div className="absolute inset-0 flex w-full flex-col items-center justify-center px-4 text-center">
          <h2 className="font-heading text-2xl text-background-50 md:text-4xl">
            追更提醒 · 新章节第一时间开读
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-6 text-background-100 md:text-base">
            收藏《寄宿日记》等心仪作品，每天打开布丁漫画网，
            都能看到最新连载，全程免费，畅读无阻。
          </p>
          <div className="mt-6 flex flex-col items-center gap-3 sm:flex-row">
            <Link
              to="/read/jsrj/1"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              马上开始阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-2.5 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              了解布丁漫画网
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}